import { render, staticRenderFns } from "./TypeServiceForm.vue?vue&type=template&id=5840e569&scoped=true&"
import script from "./TypeServiceForm.vue?vue&type=script&lang=js&"
export * from "./TypeServiceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5840e569",
  null
  
)

export default component.exports